import { useTranslation } from "react-i18next";

import { MainLayout } from "components/layouts";
import ShiftsForm from "./ShiftsForm";

import styles from "../styles/Shifts.module.css";
import { Breadcrumb, Flex, Space } from "antd";
import { useNavigate } from "react-router-dom";

const ShiftCreate = (props) => {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <MainLayout>
      <Space direction="vertical" size={24} style={{ width: "100%" }}>
        <Flex vertical>
          <Breadcrumb items={[
            { title: t("home.header"), href: "/" },
            { title: t("configuration.header"), href: "/configuration/attendance" },
            {
              title: t("attendance_setting.header"),
              href: "/configuration/attendance",
            },
            {
              title: t("shift.header"), href: "/configuration/attendance",
              onClick: (e) => {
                e.preventDefault();
                navigate("/configuration/attendance", { state: { selectedTab: 'shifts' } });
              }
            },
            { title: t("common.create") },
          ]} />
          <h2>{t("common.create")}</h2>
        </Flex>
        <ShiftsForm {...props} />
      </Space>
    </MainLayout>
  );
};

export default ShiftCreate;
